<template>
  <div class="customerAcount">
    <div class="goods_acount">
      <div>
        <span>商品金额共</span>
        <span>{{customerTotal.receivables*1}}</span>
        <span>元</span>
        <span>
          （其中
          <span v-if="customerTotal.discount<=0">订单优惠{{Math.abs(customerTotal.discount*1)}}元</span>
          <span v-if="customerTotal.discount>0">订单多收{{customerTotal.discount*1}}元</span>）
        </span>
        <span>{{customerTotal.order_count}}单</span>
        <span>，{{customerTotal.buyer_count}}个客户</span>
      </div>
      <div class="time">
        <Calendar v-model="data_picker" @change="changeTime"></Calendar>
      </div>
    </div>
    <div class="list_box" v-if="list.length>0">
      <div class="list_tl">
        <span>序号</span>
        <span>买家</span>
        <span>商品种类</span>
        <span>单数</span>
        <span>商品金额</span>
        <span>订单金额</span>
        <span>订单优惠</span>
        <span></span>
      </div>
      <div class="list_content">
        <md-scroll-view
          ref="scrollView"
          :auto-reflow="false"
          :bouncing="true"
          :scrolling-x="false"
          @end-reached="$_onEndReached"
        >
          <div
            class="list"
            v-for="(item,index) in list"
            :key="index"
            @click="goDetail(item.buyer_id)"
          >
            <span>{{index+1}}</span>
            <span>{{item.name}}</span>
            <span>{{item.good_count}}种</span>
            <span>{{item.order_count}}单</span>
            <span>{{item.receivables*1}}元</span>
            <span>{{item.order_amount*1}}元</span>
            <span>
              <span v-if="item.discount<=0">{{Math.abs(item.discount*1)}}</span>
              <span v-else>
                {{-item.discount*1}}
                <i style=" font-style:normal;font-size:0.16rem">(多收)</i>
              </span>
            </span>
            <span>
              <md-icon name="arrow-right" size="sm"></md-icon>
            </span>
          </div>
          <md-scroll-view-more
            :finished-text="list.length>0?'全部已加载':'暂无数据'"
            slot="more"
            :is-finished="isFinished"
          ></md-scroll-view-more>
        </md-scroll-view>
      </div>
    </div>
    <div v-if="list.length==0" style="text-align:center;color:#999;line-height:0.8rem">暂无数据~</div>
  </div>
</template>
<script>
import { Customer_Acount } from "@/api/work/acount/salesAcount";
import { timestampToDate } from "@/utils/timestamp";
import Calendar from "@/components/Calendar";
export default {
  name: "customerAcount",
  components: {
    Calendar,
  },
  data() {
    return {
      customerQuery: {
        s: "",
        e: "",
        page: 1,
        pagesize: 55,
      },
      data_picker: [],
      isFinished: false,
      customerTotal: {
        receivables: 0,
        discount: 0,
        order_count: 0,
        buyer_count: 0,
      },
      list: [],
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    //选择时间
    changeTime(e) {
      if (this.data_picker) {
        this.customerQuery.s = timestampToDate(this.data_picker[0]);
        this.customerQuery.e = timestampToDate(this.data_picker[1]);
      } else {
        this.customerQuery.s = "";
        this.customerQuery.e = "";
      }
      this.customerQuery.page = 1;
      this.list = [];
      this.getList();
    },
    //获取列表数据
    getList() {
      if (this.customerQuery.page == 1) {
        this.list = [];
      }
      Customer_Acount(this.customerQuery).then((res) => {
        if (res.code == 200) {
          this.customerTotal.receivables = res.data.receivables;
          this.customerTotal.discount = res.data.discount;
          this.customerTotal.order_count = res.data.order_count;
          this.customerTotal.buyer_count = res.data.buyer_count;
          this.list = this.list.concat(res.data.list);
          if (
            this.list.length == res.data.totalCount ||
            res.data.list.length == 0
          ) {
            this.isFinished = true;
          } else {
            this.isFinished = false;
            this.customerQuery.page++;
          }
        } else {
        }
      });
    },
    //下拉刷新
    $_onEndReached() {
      if (this.isFinished) {
        return;
      }
      // async data
      this.getList();
      this.$refs.scrollView.finishLoadMore();
    },

    //去详情页
    goDetail(buyer_id) {
      this.$router.push({
        path: "/data/customerAcount/customerAcountDetail",
        query: { buyer_id ,s:this.customerQuery.s,e:this.customerQuery.e},
      });
    },
  },
};
</script>
<style lang="less" scoped>
.customerAcount {
  height: 100%;
  margin: 0 0.22rem;
  .goods_acount {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 0.12rem;
    height: 0.6rem;
    border-bottom: 0.01rem solid #e5e5e5;
    > div:nth-of-type(1) {
      font-size: 0.22rem;
      color: #404040;
      > span:nth-of-type(2) {
        color: #31b158;
      }
      > span:nth-of-type(4) {
        color: #999999;
        font-size: 0.2rem;
      }
    }
  }
  .list_box {
    height: calc(100% - 0.6rem - 0.2rem);
    .list_tl {
      height: 0.68rem;
      border-bottom: 0.01rem solid #e5e5e5;
      display: flex;
      align-items: center;
      justify-content: space-between;
      > span {
        color: #555;
        font-size: 0.22rem;
        font-weight: bold;
        text-align: center;
      }
      > span:nth-of-type(1) {
        width: 0.6rem;
        text-align: left;
      }
      > span:nth-of-type(2) {
        width: 2rem;
      }
      > span:nth-of-type(3) {
        width: 1.2rem;
        text-align: center;
      }
      > span:nth-of-type(4) {
        width: 1.2rem;
        text-align: center;
      }
      > span:nth-of-type(5) {
        width: 2.6rem;
        text-align: center;
      }
      > span:nth-of-type(6) {
        width: 2.2rem;
        text-align: center;
      }
      > span:nth-of-type(7) {
        width: 2rem;
        text-align: center;
      }
      > span:nth-of-type(8) {
        width: 0.8rem;
        text-align: right;
      }
    }
    .list_content {
      height: calc(100% - 0.68rem);
      font-size: 0.18rem;
      .list {
        height: 0.6rem;
        border-bottom: 0.01rem solid #e5e5e5;
        display: flex;
        align-items: center;
        justify-content: space-between;
        > span {
          color: #666;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          text-align: center;
        }
        > span:nth-of-type(1) {
          width: 0.6rem;
          text-align: left;
        }
        > span:nth-of-type(2) {
          width: 2rem;
        }
        > span:nth-of-type(3) {
          width: 1.2rem;
        }
        > span:nth-of-type(4) {
          width: 1.2rem;
          text-align: center;
        }
        > span:nth-of-type(5) {
          width: 2.6rem;
        }
        > span:nth-of-type(6) {
          width: 2.2rem;
        }
        > span:nth-of-type(7) {
          width: 2rem;
        }
        > span:nth-of-type(8) {
          width: 0.8rem;
          text-align: right;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
<style lang="less">
.time {
  .calendar_select_box {
    width: 2.6rem!important;
    border: 0.01rem solid #e5e5e5!important;
    background: #fff !important;
  }
}
</style>